import {createStore} from 'redux';

export default () => {
	
	const store = createStore((state = {year: '2017'}, action) => {
		switch(action.type) {
			case 'CHANGE_YEAR':
				return {
					year: action.year
				}
			default:
				return state
		}
	});

	return store;
}


// WEBPACK FOOTER //
// ./src/store/configStore.js